import React from 'react'
import { Trans } from '@lingui/macro'

const NotFoundPage: React.FunctionComponent = () => {
    return (
        <div className='text-center'>
            <h1 className='text-xl font-bold mt-8 mb-4'>
                <Trans>Page not found</Trans>
            </h1>
            <p className='text-lg text-gray-600'>
                <Trans>The page you are looking for does not exist.</Trans>
            </p>
        </div>
    )
}

export default NotFoundPage
